const br = {
    "Ressecção de Tumor intracardíaco": "Ressecção de Tumor intracardíaco",
    "Transplante Cardíaco": "Transplante Cardíaco",
    "Implante de eletrodo epicárdico": "Implante de eletrodo epicárdico",
    "Janela pleuropericárdica": "Janela pleuropericárdica",
    "Pericardiectomia": "Pericardiectomia",
    "Cox Maze": "Cox Maze",
    "Fechamento de auriculeta": "Fechamento de auriculeta",
    "(cm)": "(cm)",
    "(kg)": "(kg)",
    "(kg/m2)": "(kg/m2)",
    "(m2)": "(m2)",
    "(em uso de broncodilatador inalatório)": "(em uso de broncodilatador inalatório)",
    "(prévia à cirurgia)": "(prévia à cirurgia)",
    "(prescrição nutricional, de exercícios ou estratégias de psicoterapia para melhorar a capacidade funcional no pré-operatório)": "(prescrição nutricional, de exercícios ou estratégias de psicoterapia para melhorar a capacidade funcional no pré-operatório)",
    "(%)": "(%)",
    "(mg/dl)": "(mg/dl)",
    "(pior dispneia ou classe funcional nas últimas 2 semanas)": "(pior dispneia ou classe funcional nas últimas 2 semanas)",
    "(Classificação de angina da Canadian Cardiovascular Society)": "(Classificação de angina da Canadian Cardiovascular Society)",
    "(%, mortalidade)": "(%, mortalidade)",
    "(1 ponto para cada resposta positiva: Fadigado? Não consegue subir 1 lance de escadas? Não consegue caminhar um quarteirão? Possui mais de 5 doenças? Perdeu mais de 5% do peso nos últimos 6 meses?)": "(1 ponto para cada resposta positiva: Fadigado? Não consegue subir 1 lance de escadas? Não consegue caminhar um quarteirão? Possui mais de 5 doenças? Perdeu mais de 5% do peso nos últimos 6 meses?)",
    "(e.g. Morfina 10 mg e Fentanil 300 mcg)": "(e.g. Morfina 10 mg e Fentanil 300 mcg)",
    "(beating heart surgery)": "(beating heart surgery)",
    "(Marca/especificação)": "(Marca/especificação)",
    "(Fr)": "(Fr)",
    "(min)": "(min)",
    "(min, 'de pele a pele')": "(min, 'de pele a pele')",
    "(qualquer lesão de pelo menos 50%)": "(qualquer lesão de pelo menos 50%)",
    "(mm)": "(mm)",
    "(horas)": "(horas)",
    "(dias, após a cirurgia)": "(dias, após a cirurgia)",
    "ID do paciente" : "ID do paciente",
    "Hospital" : "Hospital",
    "ID no hospital" : "ID no hospital",
    "Nome" : "Nome",
    "CPF" : "CPF",
    "Idade" : "Idade",
    "Sexo" : "Sexo",
    "Altura" : "Altura",
    "Peso" : "Peso",
    "IMC" : "IMC",
    "Área de superfície corpórea" : "Área de superfície corpórea",
    "HAS" : "HAS",
    "DM" : "DM",
    "DM em uso de insulina" : "DM em uso de insulina",
    "DPOC" : "DPOC",
    "IAM prévio" : "IAM prévio",
    "AVE prévio" : "AVE prévio",
    "FA" : "FA",
    "Doença arterial obstrutiva periférica" : "Doença arterial obstrutiva periférica",
    "Pré-habilitação" : "Pré-habilitação",
    "Esternotomia prévia" : "Esternotomia prévia",
    "Cirurgia cardíaca sem esternotomia prévia" : "Cirurgia cardíaca sem esternotomia prévia",
    "Cirurgia torácica não cardíaca prévia" : "Cirurgia torácica não cardíaca prévia",
    "Angioplastia prévia" : "Angioplastia prévia",
    "FEVE" : "FEVE",
    "Creatinina" : "Creatinina",
    "NYHA" : "NYHA",
    "CCS" : "CCS",
    "EuroSCORE" : "EuroSCORE",
    "STS" : "STS",
    "FRAIL scale" : "FRAIL scale",
    "Uso de intubação seletiva" : "Uso de intubação seletiva",
    "Método de intubação seletiva" : "Método de intubação seletiva",
    "Bloqueio regional" : "Bloqueio regional",
    "Técnica de bloqueio regional" : "Técnica de bloqueio regional",
    "Momento do bloqueio regional" : "Momento do bloqueio regional",
    "Monitorização de débito minimamente invasiva" : "Monitorização de débito minimamente invasiva",
    "Monitor minimamente invasivo utilizado" : "Monitor minimamente invasivo utilizado",
    "Monitorização de débito invasiva" : "Monitorização de débito invasiva",
    "Monitor invasivo utilizado" : "Monitor invasivo utilizado",
    "Monitorização do Sistema Nervoso Central" : "Monitorização do Sistema Nervoso Central",
    "Tipo de monitorizacão de SNC" : "Tipo de monitorizacão de SNC",
    "Manutenção de ventilação durante a CEC" : "Manutenção de ventilação durante a CEC",
    "Consumo total de opioides" : "Consumo total de opioides",
    "Uso de dexmedetomidina" : "Uso de dexmedetomidina",
    "Extubação em sala" : "Extubação em sala",
    "Localização" : "Localização",
    "Mediana" : "Mediana",
    "Tipo de esternotomia" : "Tipo de esternotomia",
    "Lateralidade " : "Lateralidade ",
    "Posição" : "Posição",
    "Tamanho da incisão" : "Tamanho da incisão",
    "Categoria do tamanho" : "Categoria do tamanho",
    "Número de incisões adicionais" : "Número de incisões adicionais",
    "Incisão de trabalho na pele" : "Incisão de trabalho na pele",
    "Espaço intercostal aberto" : "Espaço intercostal aberto",
    "Conversão para esternotomia" : "Conversão para esternotomia",
    "Motivo da conversão" : "Motivo da conversão",
    "Estratégia de canulação" : "Estratégia de canulação",
    "Método de canulação periférica" : "Método de canulação periférica",
    "Assistência sem parada cardíaca" : "Assistência sem parada cardíaca",
    "Sítio de canulação arterial" : "Sítio de canulação arterial",
    "Cânula arterial utilizada" : "Cânula arterial utilizada",
    "Tamanho da cânula arterial" : "Tamanho da cânula arterial",
    "Estratégia de canulação venosa" : "Estratégia de canulação venosa",
    "Cânula venosa única utilizada" : "Cânula venosa única utilizada",
    "Tamanho da cânula venosa única" : "Tamanho da cânula venosa única",
    "Número de estágios da cânula única" : "Número de estágios da cânula única",
    "Cânula venosa superior utilizada" : "Cânula venosa superior utilizada",
    "Tamanho da cânula venosa superior" : "Tamanho da cânula venosa superior",
    "Cânula venosa inferior utilizada" : "Cânula venosa inferior utilizada",
    "Tamanho da cânula venosa inferior" : "Tamanho da cânula venosa inferior",
    "Laçamento das cavas" : "Laçamento das cavas",
    "Descompressão de câmaras esquerdas" : "Descompressão de câmaras esquerdas",
    "Tipo de clampeamento" : "Tipo de clampeamento",
    "Perfusão cerebral seletiva" : "Perfusão cerebral seletiva",
    "Tempo de CEC" : "Tempo de CEC",
    "Tempo de anóxia/clampeamento" : "Tempo de anóxia/clampeamento",
    "Tempo de perfusão cerebral seletiva" : "Tempo de perfusão cerebral seletiva",
    "Tempo total da cirurgia" : "Tempo total da cirurgia",
    "Cardioplegia utilizada" : "Cardioplegia utilizada",
    "Necessidade de repetir cardioplegia" : "Necessidade de repetir cardioplegia",
    "Tipo de infusão da cardioplegia" : "Tipo de infusão da cardioplegia",
    "Temperatura mínima em CEC (ºC)" : "Temperatura mínima em CEC (ºC)",
    "Fluxo alvo da CEC (ml/min)" : "Fluxo alvo da CEC (ml/min)",
    "Necessidade de assistência para saída de CEC" : "Necessidade de assistência para saída de CEC",
    "Assistência utilizada na saída de CEC" : "Assistência utilizada na saída de CEC",
    "Uso de miniCEC" : "Uso de miniCEC",
    "Revascularização" : "Revascularização",
    "Abordagem valvar" : "Abordagem valvar",
    "Abordagem da Aorta" : "Abordagem da Aorta",
    "Correção de cardiopatia congênita" : "Correção de cardiopatia congênita",
    "Outros Procedimentos Cardíacos" : "Outros Procedimentos Cardíacos",
    "Uso de videotoracoscopia" : "Uso de videotoracoscopia",
    "Uso de plataforma robótica" : "Uso de plataforma robótica",
    "Plataforma robótica utilizada" : "Plataforma robótica utilizada",
    "Revascularização com CEC" : "Revascularização com CEC",
    "Número de coronárias acometidas" : "Número de coronárias acometidas",
    "Número de coronárias abordadas" : "Número de coronárias abordadas",
    "Número de enxertos utilizados" : "Número de enxertos utilizados",
    "Uso da mamária esquerda" : "Uso da mamária esquerda",
    "Método de dissecção da mamária esquerda" : "Método de dissecção da mamária esquerda",
    "Material utilizado na dissecção da mamária esquerda" : "Material utilizado na dissecção da mamária esquerda",
    "Uso da mamária direita" : "Uso da mamária direita",
    "Método de dissecção da mamária direita" : "Método de dissecção da mamária direita",
    "Material utilizado na dissecção da mamária direita" : "Material utilizado na dissecção da mamária direita",
    "Uso de A. radial" : "Uso de A. radial",
    "Retirada endoscópica da radial" : "Retirada endoscópica da radial",
    "Uso de A. gastroepiploica" : "Uso de A. gastroepiploica",
    "Uso de A. epigástrica inferior" : "Uso de A. epigástrica inferior",
    "Uso de V. safena magna" : "Uso de V. safena magna",
    "Uso da técnica safena no-touch" : "Uso da técnica safena no-touch",
    "Retirada endoscópica da safena" : "Retirada endoscópica da safena",
    "Uso de enxertos compostos" : "Uso de enxertos compostos",
    "Uso de ténica em Y" : "Uso de ténica em Y",
    "Uso de anastomoses sequenciais" : "Uso de anastomoses sequenciais",
    "Uso de estabilizador cardíaco" : "Uso de estabilizador cardíaco",
    "Estabilizador utilizado" : "Estabilizador utilizado",
    "Uso de posicionador cardíaco" : "Uso de posicionador cardíaco",
    "Posicionador utilizado" : "Posicionador utilizado",
    "Material utilizado na anastomose coronariana" : "Material utilizado na anastomose coronariana",
    "Marca do material de mini utilizado" : "Marca do material de mini utilizado",
    "Angioplastia programada (cirurgia híbrida)" : "Angioplastia programada (cirurgia híbrida)",
    "Abordagem da valva aórtica" : "Abordagem da valva aórtica",
    "Técnica de plastia valvar aórtica" : "Técnica de plastia valvar aórtica",
    "Gradiente Médio Valvar Aórtico Pós-CEC" : "Gradiente Médio Valvar Aórtico Pós-CEC",
    "Insuficiência aórtica pós-CEC" : "Insuficiência aórtica pós-CEC",
    "Prótese valvar aórtica" : "Prótese valvar aórtica",
    "Tamanho da prótese valvar aórtica" : "Tamanho da prótese valvar aórtica",
    "Prótese de liberação rápida aórtica" : "Prótese de liberação rápida aórtica",
    "Uso de prótese aórtica endovascular" : "Uso de prótese aórtica endovascular",
    "Prótese aórtica com tratamento anticalcificante" : "Prótese aórtica com tratamento anticalcificante",
    "Especificações da prótese aórtica" : "Especificações da prótese aórtica",
    "Leak paravalvar aórtico" : "Leak paravalvar aórtico",
    "Abordagem da valva mitral" : "Abordagem da valva mitral",
    "Via de acesso da valva mitral" : "Via de acesso da valva mitral",
    "Plastia valvar mitral" : "Plastia valvar mitral",
    "Troca valvar mitral" : "Troca valvar mitral",
    "Comissurotomia mitral" : "Comissurotomia mitral",
    "Uso de neocorda" : "Uso de neocorda",
    "Especificações da neocorda" : "Especificações da neocorda",
    "Uso de anel mitral" : "Uso de anel mitral",
    "Especificações do anel mitral" : "Especificações do anel mitral",
    "Ressecção de folheto mitral" : "Ressecção de folheto mitral",
    "Anuloplastia posterior mitral" : "Anuloplastia posterior mitral",
    "Gradiente médio da valva mitral pós-CEC" : "Gradiente médio da valva mitral pós-CEC",
    "Insuficiência mitral pós-CEC" : "Insuficiência mitral pós-CEC",
    "Prótese valvar mitral" : "Prótese valvar mitral",
    "Tamanho da Prótese Valvar Mitral" : "Tamanho da Prótese Valvar Mitral",
    "Prótese de liberação rápida mitral" : "Prótese de liberação rápida mitral",
    "Uso de prótese mitral endovascular" : "Uso de prótese mitral endovascular",
    "Prótese mitral com tratamento anticalcificante" : "Prótese mitral com tratamento anticalcificante",
    "Especificações da prótese mitral" : "Especificações da prótese mitral",
    "Leak paravalvar mitral" : "Leak paravalvar mitral",
    "Fechamento de auriculeta esquerda" : "Fechamento de auriculeta esquerda",
    "Abordagem da valva pulmonar" : "Abordagem da valva pulmonar",
    "Plastia valvar pulmonar" : "Plastia valvar pulmonar",
    "Troca valvar pulmonar" : "Troca valvar pulmonar",
    "Técnica de plastia valvar pulmonar" : "Técnica de plastia valvar pulmonar",
    "Gradiente médio valvar pulmonar pós-CEC" : "Gradiente médio valvar pulmonar pós-CEC",
    "Insuficiência pulmonar pós-CEC" : "Insuficiência pulmonar pós-CEC",
    "Prótese valvar pulmonar" : "Prótese valvar pulmonar",
    "Tamanho da prótese valvar pulmonar" : "Tamanho da prótese valvar pulmonar",
    "Prótese de liberação rápida pulmonar" : "Prótese de liberação rápida pulmonar",
    "Uso de prótese pulmonar endovascular" : "Uso de prótese pulmonar endovascular",
    "Prótese pulmonar com tratamento anticalcificante" : "Prótese pulmonar com tratamento anticalcificante",
    "Especificações da prótese pulmonar" : "Especificações da prótese pulmonar",
    "Leak paravalvar pulmonar" : "Leak paravalvar pulmonar",
    "Abordagem da valva tricúspide" : "Abordagem da valva tricúspide",
    "Plastia valvar tricúspide" : "Plastia valvar tricúspide",
    "Troca valvar tricúspide" : "Troca valvar tricúspide",
    "Técnica de plastia valvar tricúspide" : "Técnica de plastia valvar tricúspide",
    "Especificações do anel tricúspide" : "Especificações do anel tricúspide",
    "Gradiente médio valvar tricúspide pós-CEC" : "Gradiente médio valvar tricúspide pós-CEC",
    "Insuficiência valvar tricúspide pós-CEC" : "Insuficiência valvar tricúspide pós-CEC",
    "Prótese valvar tricúspide" : "Prótese valvar tricúspide",
    "Tamanho da prótese valvar tricúspide" : "Tamanho da prótese valvar tricúspide",
    "Prótese de liberação rápida tricúspide" : "Prótese de liberação rápida tricúspide",
    "Uso de prótese tricúspide endovascular" : "Uso de prótese tricúspide endovascular",
    "Prótese tricúspide com tratamento anticalcificante" : "Prótese tricúspide com tratamento anticalcificante",
    "Especificações da prótese tricúspide" : "Especificações da prótese tricúspide",
    "Leak paravalvar tricúspide" : "Leak paravalvar tricúspide",
    "Segmentos da aorta abordados" : "Segmentos da aorta abordados",
    "Reimplante de coronárias" : "Reimplante de coronárias",
    "Preservação da valva aórtica nativa" : "Preservação da valva aórtica nativa",
    "Uso de tubo sintético" : "Uso de tubo sintético",
    "Tamanho do Tubo Sintético" : "Tamanho do Tubo Sintético",
    "Uso de tubo valvado" : "Uso de tubo valvado",
    "Tipo de valva do tubo valvado" : "Tipo de valva do tubo valvado",
    "Especificações do material utilizado na Aorta" : "Especificações do material utilizado na Aorta",
    "Programação de Procedimento Híbrido" : "Programação de Procedimento Híbrido",
    "Cardiopatia congênita abordada" : "Cardiopatia congênita abordada",
    "Uso de pericárdio" : "Uso de pericárdio",
    "Uso de afastador de partes moles" : "Uso de afastador de partes moles",
    "Especificações do afastador de partes moles" : "Especificações do afastador de partes moles",
    "Luxação, fratura de costelas/articulação costocondral" : "Luxação, fratura de costelas/articulação costocondral",
    "Uso de fixação rígida" : "Uso de fixação rígida",
    "Sítio da fixação rígida" : "Sítio da fixação rígida",
    "Especificações da prótese de fixação rígida" : "Especificações da prótese de fixação rígida",
    "Pericardiotomia posterior esquerda" : "Pericardiotomia posterior esquerda",
    "Drenagem pericárdica" : "Drenagem pericárdica",
    "Drenagem pleural" : "Drenagem pleural",
    "Tipo de dreno pleural utilizado" : "Tipo de dreno pleural utilizado",
    "Tempo de extubação após admissão na UTI" : "Tempo de extubação após admissão na UTI",
    "Tempo de permanência em Unidade de Terapia Intensiva" : "Tempo de permanência em Unidade de Terapia Intensiva",
    "Tempo de permanência em internação Hospitalar" : "Tempo de permanência em internação Hospitalar",
    "Dor pós-operatória relatada" : "Dor pós-operatória relatada",
    "Escala visual analógica da dor" : "Escala visual analógica da dor",
    "Tempo para início de mobilização no leito" : "Tempo para início de mobilização no leito",
    "Tempo para início de deambulação" : "Tempo para início de deambulação",
    "Infecção" : "Infecção",
    "Deiscência de ferida operatória " : "Deiscência de ferida operatória ",
    "Infarto do miocárdio pós-operatório" : "Infarto do miocárdio pós-operatório",
    "Necessidade de nova revascularização não programada durante internação " : "Necessidade de nova revascularização não programada durante internação ",
    "Derrame pleural" : "Derrame pleural",
    "Tamponamento cardíaco" : "Tamponamento cardíaco",
    "Necessidade de primeira diálise" : "Necessidade de primeira diálise",
    "AVE novo com sequela" : "AVE novo com sequela",
    "Fibrilação Atrial pós-operatória" : "Fibrilação Atrial pós-operatória",
    "Parada cardiorrespiratória revertida no pós-operatório" : "Parada cardiorrespiratória revertida no pós-operatório",
    "Necessidade de Dispositivo de Assistência Circulatória no pós-operatório" : "Necessidade de Dispositivo de Assistência Circulatória no pós-operatório",
    "Tipo de dispositivo de assistência circulatória " : "Tipo de dispositivo de assistência circulatória ",
    "Tempo para início da retirada dos drenos (horas)" : "Tempo para início da retirada dos drenos (horas)",
    "Readmissão hospitalar" : "Readmissão hospitalar",
    "Transfusão de hemoderivados" : "Transfusão de hemoderivados",
    "Momento da transfusão" : "Momento da transfusão",
    "Elemento transfundido" : "Elemento transfundido",
    "Óbito intra-hospitalar" : "Óbito intra-hospitalar",
    "Motivo do óbito" : "Motivo do óbito",
    "Momento do óbito" : "Momento do óbito",
    "Óbito durante seguimento" : "Óbito durante seguimento",
    "Tempo do óbito após cirurgia (dias)" : "Tempo do óbito após cirurgia (dias)",
    "Tipo de Valva do Tubo Valvado": "Tipo de Valva do Tubo Valvado",
    "Gradiente Médio Valvar Pulmonar Pós-CEC (mmHg)": "Gradiente Médio Valvar Pulmonar Pós-CEC (mmHg)",
    "Abordagem Valvar": "Abordagem Valvar",
    "Correção de Cardiopatia Congênita": "Correção de Cardiopatia Congênita",
    "Uso de Videotoracoscopia": "Uso de Videotoracoscopia",
    "Uso de Plataforma Robótica": "Uso de Plataforma Robótica",
    "Uso de Afastador de Partes Moles": "Uso de Afastador de Partes Moles",
    "Especificações do Afastador de Partes Moles": "Especificações do Afastador de Partes Moles",
    "Uso de Fixação Rígida": "Uso de Fixação Rígida",
    "Sítio da Fixação Rígida": "Sítio da Fixação Rígida",
    "Especificações da Prótese de Fixação Rígida": "Especificações da Prótese de Fixação Rígida",
    "Pericardiotomia Posterior Esquerda": "Pericardiotomia Posterior Esquerda",
    "Drenagem Pericárdica": "Drenagem Pericárdica",
    "Drenagem Pleural": "Drenagem Pleural",
    "Tipo de Dreno Pleural Utilizado": "Tipo de Dreno Pleural Utilizado",
    "Plataforma Robótica Utilizada": "Plataforma Robótica Utilizada",
    "Número de Coronárias Acometidas": "Número de Coronárias Acometidas",
    "Número de Coronárias Abordadas": "Número de Coronárias Abordadas",
    "Número de Enxertos Utilizados": "Número de Enxertos Utilizados",
    "Uso de ATIE": "Uso de ATIE",
    "Método de Dissecção da ATIE": "Método de Dissecção da ATIE",
    "Material Utilizado na Dissecção da ATIE": "Material Utilizado na Dissecção da ATIE",
    "Uso de ATID": "Uso de ATID",
    "Método de Dissecção da ATID": "Método de Dissecção da ATID",
    "Material Utilizado na Dissecção da ATID": "Material Utilizado na Dissecção da ATID",
    "Uso de A. Radial": "Uso de A. Radial",
    "Uso de A. Gastroepiploica": "Uso de A. Gastroepiploica",
    "Uso de A. Epigástrica Inferior": "Uso de A. Epigástrica Inferior",
    "Uso de V. Safena Magna": "Uso de V. Safena Magna",
    "Uso de Estabilizador Cardíaco": "Uso de Estabilizador Cardíaco",
    "Uso de Posicionador Cardíaco": "Uso de Posicionador Cardíaco",
    "Material Utilizado na Anastomose Coronariana": "Material Utilizado na Anastomose Coronariana",
    "Marca do Material de Mini Utilizado": "Marca do Material de Mini Utilizado",
    "Angioplastia Programada (Cirurgia Híbrida)": "Angioplastia Programada (Cirurgia Híbrida)",
    "Abordagem da Valva Aórtica": "Abordagem da Valva Aórtica",
    "Abordagem da Valva Mitral": "Abordagem da Valva Mitral",
    "Abordagem da Valva Pulmonar": "Abordagem da Valva Pulmonar",
    "Abordagem da Valva Tricúspide": "Abordagem da Valva Tricúspide",
    "Segmentos da Aorta Abordados": "Segmentos da Aorta Abordados",
    "Uso de Tubo Sintético": "Uso de Tubo Sintético",
    "Especificações do Material Utilizado na Aorta": "Especificações do Material Utilizado na Aorta",
    "Cardiopatia Congênita Abordada": "Cardiopatia Congênita Abordada",
    "Uso de Pericárdio": "Uso de Pericárdio",
    "Retirada Endoscópica da Radial": "Retirada Endoscópica da Radial",
    "Uso da Técnica Safena No-Touch": "Uso da Técnica Safena No-Touch",
    "Retirada Endoscópica da Safena": "Retirada Endoscópica da Safena",
    "Uso de Enxertos Compostos": "Uso de Enxertos Compostos",
    "Estabilizador Utilizado": "Estabilizador Utilizado",
    "Posicionador Utilizado": "Posicionador Utilizado",
    "Plastia Valvar Aórtica": "Plastia Valvar Aórtica",
    "Troca Valvar Aórtica": "Troca Valvar Aórtica",
    "Via de Acesso da Valva Mitral": "Via de Acesso da Valva Mitral",
    "Plastia Valvar Mitral": "Plastia Valvar Mitral",
    "Troca Valvar Mitral": "Troca Valvar Mitral",
    "Fechamento de Auriculeta Esquerda": "Fechamento de Auriculeta Esquerda",
    "Plastia Valvar Pulmonar": "Plastia Valvar Pulmonar",
    "Troca Valvar Pulmonar": "Troca Valvar Pulmonar",
    "Plastia Valvar Tricúspide": "Plastia Valvar Tricúspide",
    "Troca Valvar Tricúspide": "Troca Valvar Tricúspide",
    "Reimplante de Coronárias": "Reimplante de Coronárias",
    "Preservação da Valva Aórtica Nativa": "Preservação da Valva Aórtica Nativa",
    "Uso de Tubo Valvado": "Uso de Tubo Valvado",
    "Uso de Técnica em Y": "Uso de Técnica em Y",
    "Uso de Anastomoses Sequenciais": "Uso de Anastomoses Sequenciais",
    "Técnica de Plastia Valvar Aórtica": "Técnica de Plastia Valvar Aórtica",
    "Insuficiência Aórtica Pós-CEC": "Insuficiência Aórtica Pós-CEC",
    "Prótese Valvar Aórtica": "Prótese Valvar Aórtica",
    "Tamanho da Prótese Valvar Aórtica (mm)": "Tamanho da Prótese Valvar Aórtica (mm)",
    "Prótese de Liberação Rápida Aórtica": "Prótese de Liberação Rápida Aórtica",
    "Especificações da Prótese Aórtica": "Especificações da Prótese Aórtica",
    "Leak Paravalvar Aórtico": "Leak Paravalvar Aórtico",
    "Comissurotomia Mitral": "Comissurotomia Mitral",
    "Uso de Neocorda": "Uso de Neocorda",
    "Especificações da Neocorda": "Especificações da Neocorda",
    "Uso de Anel Mitral": "Uso de Anel Mitral",
    "Especificações do Anel Mitral": "Especificações do Anel Mitral",
    "Ressecção de Folheto Mitral": "Ressecção de Folheto Mitral",
    "Anuloplastia Posterior Mitral": "Anuloplastia Posterior Mitral",
    "Gradiente Médio Valva Mitral Pós-CEC": "Gradiente Médio Valva Mitral Pós-CEC",
    "Insuficiência Mitral Pós-CEC": "Insuficiência Mitral Pós-CEC",
    "Prótese Valvar Mitral": "Prótese Valvar Mitral",
    "Prótese de Liberação Rápida Mitral": "Prótese de Liberação Rápida Mitral",
    "Especificações da Prótese Mitral": "Especificações da Prótese Mitral",
    "Leak Paravalvar Mitral": "Leak Paravalvar Mitral",
    "Técnica de Plastia Valvar Pulmonar": "Técnica de Plastia Valvar Pulmonar",
    "Gradiente Médio Valvar Pulmonar Pós-CEC": "Gradiente Médio Valvar Pulmonar Pós-CEC",
    "Insuficiência Pulmonar Pós-CEC": "Insuficiência Pulmonar Pós-CEC",
    "Prótese Valvar Pulmonar": "Prótese Valvar Pulmonar",
    "Tamanho da Prótese Valvar Pulmonar": "Tamanho da Prótese Valvar Pulmonar",
    "Prótese de Liberação Rápida Pulmonar": "Prótese de Liberação Rápida Pulmonar",
    "Uso de Prótese Pulmonar Endovascular": "Uso de Prótese Pulmonar Endovascular",
    "Prótese Pulmonar com Tratamento Anticalcificante": "Prótese Pulmonar com Tratamento Anticalcificante",
    "Especificações da Prótese Pulmonar": "Especificações da Prótese Pulmonar",
    "Leak Paravalvar Pulmonar": "Leak Paravalvar Pulmonar",
    "Técnica de Plastia Valvar Tricúspide": "Técnica de Plastia Valvar Tricúspide",
    "Gradiente Médio Valvar Tricúspide Pós-CEC": "Gradiente Médio Valvar Tricúspide Pós-CEC",
    "Insuficiência Valvar Tricúspide Pós-CEC": "Insuficiência Valvar Tricúspide Pós-CEC",
    "Prótese Valvar Tricúspide": "Prótese Valvar Tricúspide",
    "Tamanho da Prótese Valvar Tricúspide": "Tamanho da Prótese Valvar Tricúspide",
    "Prótese de Liberação Rápida Tricúspide": "Prótese de Liberação Rápida Tricúspide",
    "Uso de Prótese Tricúspide Endovascular": "Uso de Prótese Tricúspide Endovascular",
    "Prótese Tricúspide com Tratamento Anticalcificante": "Prótese Tricúspide com Tratamento Anticalcificante",
    "Especificações da Prótese Tricúspide": "Especificações da Prótese Tricúspide",
    "Leak Paravalvar Tricúspide": "Leak Paravalvar Tricúspide",
    "Edit_Hemotransfusao" : "Edição Hemotransfusão",
    "Edit_Obito": "Edição Óbito",
    "Add_Obito": "Adicionar Óbito",
    "Momento do óbito (Intra-operatório, UTI, Enfermaria)": "Momento do óbito (Intra-operatório, UTI, Enfermaria)",
    "Voltar": "Voltar",
    "Update": "Atualizar",
    "Create": "Criar",
    "Tempo de permanência em Unidade de Terapia Intensiva (horas)": "Tempo de permanência em Unidade de Terapia Intensiva (horas)",
    "Tempo de permanência em internação Hospitalar (dias)": "Tempo de permanência em internação Hospitalar (dias)",
    "Tempo de extubação após admissão na UTI (horas)": "Tempo de extubação após admissão na UTI (horas)",
    "Dor pós-operatória": "Dor pós-operatória",
    "Escala visual analógica da dor (0-10)": "Escala visual analógica da dor (0-10)",
    "Tempo para início de mobilização no leito (horas)": "Tempo para início de mobilização no leito (horas)",
    "Tempo para início de deambulação (horas)": "Tempo para início de deambulação (horas)",
    "Deiscência de ferida operatória": "Deiscência de ferida operatória",
    "Necessidade de nova revascularização não programada": "Necessidade de nova revascularização não programada",
    "Necessidade de Dispositivo de Assistência Circulatória": "Necessidade de Dispositivo de Assistência Circulatória",
    "Tipo de dispositivo de assistência circulatória": "Tipo de dispositivo de assistência circulatória",
    "Cânula venosa superior utilizada (Marca/Especificação)": "Cânula venosa superior utilizada (Marca/Especificação)",
    "tipo_canulacao": "Tipo de canulação",
    "tipo_clampeamento": "Tipo de clampeamento",
    "tempo_total_cirurgia_min": "Tempo total da cirurgia (min, 'de pele a pele')",
    "Tipo de canulação": "Tipo de canulação",
    "Exturbação em sala": "Exturbação em sala",
    "Sem canulação": "Sem canulação",
    "Periférica": "Periférica",
    "Central": "Central",
    "Mista": "Mista",
    "Punção": "Punção",
    "Dissecção": "Dissecção",
    "Punção por visão direta": "Punção por visão direta",
    "Sim": "Sim",
    "Não": "Não",
    "Canulação arterial": "Canulação arterial",
    "Aorta ascendente": "Aorta ascendente",
    "Arco aórtico": "Arco aórtico",
    "Tronco braquiocefálico": "Tronco braquiocefálico",
    "Axilar": "Axilar",
    "Subclávia": "Subclávia",
    "Carotídea": "Carotídea",
    "Femoral": "Femoral",
    "Ilíaca externa": "Ilíaca externa",
    "Tamanho da cânula arterial (Fr)": "Tamanho da cânula arterial (Fr)",
    "Canulação venosa": "Canulação venosa",
    "Atrial única": "Atrial única",
    "Bicaval": "Bicaval",
    "Femoral única": "Femoral única",
    "Jugular única": "Jugular única",
    "Jugular + femoral": "Jugular + femoral",
    "Cava superior + femoral": "Cava superior + femoral",
    "Bicaval + cava esquerda": "Bicaval + cava esquerda",
    "Outra": "Outra",
    "Tamanho da cânula venosa única (Fr)": "Tamanho da cânula venosa única (Fr)",
    "Estágio único": "Estágio único",
    "Duplo estágio": "Duplo estágio",
    "Triplo estágio": "Triplo estágio",
    "Multiperfurada": "Multiperfurada",
    "Tamanho da cânula venosa superior (Fr)": "Tamanho da cânula venosa superior (Fr)",
    "Tamanho da cânula venosa inferior (Fr)": "Tamanho da cânula venosa inferior (Fr)",
    "Sem clampeamento": "Sem clampeamento",
    "Convencional": "Convencional",
    "Assistência sem parada cardíaca (beating heart)": "Assistência sem parada cardíaca (beating heart)",
    "Endoclamp": "Endoclamp",
    "Chitwood": "Chitwood",
    "Cânula arterial utilizada (Marca/Especificação)": "Cânula arterial utilizada (Marca/Especificação)",
    "Tempo de CEC (min)": "Tempo de CEC (min)",
    "Tempo de anóxia/clampeamento (min)": "Tempo de anóxia/clampeamento (min)",
    "Tempo de perfusão cerebral seletiva (min)": "Tempo de perfusão cerebral seletiva (min)",
    "Tempo total da cirurgia (min, 'de pele a pele')": "Tempo total da cirurgia (min, 'de pele a pele')",
    "Cirurgia em assistência": "Cirurgia em assistência",
    "Del Nido": "Del Nido",
    "Custodiol": "Custodiol",
    "Anterógrada": "Anterógrada",
    "Retrógrada": "Retrógrada",
    "Combinada": "Combinada",
    "Cânula venosa única utilizada (Marca/Especificação)": "Cânula venosa única utilizada (Marca/Especificação)",
    "Balão intra-aórtico": "Balão intra-aórtico",
    "Centrimag": "Centrimag",
    "ECMO VA": "ECMO VA",
    "ECMO VV": "ECMO VV",
    "Berlin Heart": "Berlin Heart",
    "HeartMate": "HeartMate",
    "Selecione": "Selecione",
    "localizacao": "Localização", 
    "mediana" :"Mediana", 
    "tamanho_incisao" : "Tamanho da incisão (cm)", 
    "categoria_tamanho" : "Categoria do tamanho",
    "Tamanho da incisão (cm)": "Tamanho da incisão (cm)",
    "Lateralidade": "Lateralidade",
    "Endoscópica <= 2cm": "Endoscópica <= 2cm",
    "Microincisão 2-4cm": "Microincisão 2-4cm",
    "Miniincisão 4-6cm": "Miniincisão 4-6cm",
    "Convencional >= 6cm": "Convencional >= 6cm",
    "Edit_Incisao": "Editar Incisão",
    "Add_Incisao": "Adicionar Incisão",
    "Operacao_cancelada": "Operação cancelada",
    "Yes": "Sim",
    "No": "Não",
    "Confirmar": "Confirmar",
    "Edit_Anestesia": "Editar Anestesia",
    "Add_Anestesia": "Adicionar Anestesia",
    "Monitorização de SNC": "Monitorização de SNC",
    "Tipo de monitorização de SNC": "Tipo de monitorização de SNC",
    "EUROscore (%)": "EUROscore (%)",
    "STS score (%)": "STS score (%)",
    "Edit_Escore": "Editar Escores",
    "Add_Escore": "Adicionar Escores",
    "nyha": "Classificação NYHA",
    "ccs": "Classificação CCS",
    "euroscore": "EUROscore (%)",
    "sts_score": "STS score (%)",
    "frail_score": "Frail score",
    "select_options": "Selecione as opções",
    "save": "Salvar",
    "back": "Voltar",
    "edit_escores": "Editar Escores",
    "add_escores": "Adicionar Escores",
    "select_nyha": "Selecione a classificação NYHA",
    "select_ccs": "Selecione a classificação CCS",
    "select_frail_score": "Selecione o Frail Score",
    "required_field": "Este campo é obrigatório",
    "confirm_save": "Confirmar Salvar",
    "yes": "Sim",
    "no": "Não",
    "altura": "Altura",
    "Confirmar_salvar": "Gostaria de confirmar a sua alteração?",
    "peso": "Peso",
    "Os seguintes campos são obrigatórios:": "Os seguintes campos são obrigatórios:",
    "operation_canceled": "Operação cancelada",
    "operation_success": "Operação realizada com sucesso",
    "data_nascimento": "Data de Nascimento",
    "Save": "Salvar",
    "ASC": "ASC",
    "FA pré-operatória": "Fibrilação Atrial Pré-operatória",
    "DAOP": "Doença Arterial Obstrutiva Periférica",
    "Pré-habilitado": "Pré-habilitado",
    "pre_habilitacao": "Pré-habilitação",
    "Cirurgia torácica prévia": "Cirurgia Torácica Prévia",
    "FEVE (%)": "Fração de Ejeção Ventricular Esquerda (%)",
    "Creatinina (mg/dl)": "Creatinina (mg/dl)",
    "AngioplastiaPrevia": "Angioplastia Prévia",
    "Select_Sexo": "Selecione o sexo",
    "Masculino": "Masculino",
    "Feminino": "Feminino",
    "Edit_PreOperatorio": "Editar Pré-operatório",
    "Add_PreOperatorio": "Adicionar Pré-operatório",
    "Campos_Obrigatorios": "Os seguintes campos são obrigatórios:",
    "Identificacao": "Identificação",
    "Identificacao_Descricao": "Formulário que coleta dados básicos de identificação do paciente",
    "PreOperatorio": "Pré-operatório",
    "PreOperatorio_Descricao": "Avaliação prévia à cirurgia, com foco em exames e preparação do paciente",
    "Escores": "Escores",
    "Escores_Descricao": "Coleta de escores clínicos para avaliação do estado de saúde do paciente",
    "Anestesia": "Anestesia",
    "Anestesia_Descricao": "Informações sobre o processo anestésico e sedação do paciente",
    "Incisao": "Incisão",
    "Incisao_Descricao": "Registro do início da cirurgia, com detalhes sobre a incisão",
    "Circulacao_Extracorporea": "Circulação Extracorpórea",
    "Circulacao_Extracorporea_Descricao": "Informações sobre o uso da circulação extracorpórea durante a cirurgia",
    "Cirurgia": "Cirurgia",
    "Cirurgia_Descricao": "Detalhes do procedimento cirúrgico principal realizado no paciente",
    "PosOperatorio": "Pós-operatório",
    "PosOperatorio_Descricao": "Monitoramento e cuidados imediatos no pós-operatório",
    "Hemotransfusao": "Hemotransfusão",
    "Hemotransfusao_Descricao": "Registro de transfusões sanguíneas realizadas durante ou após a cirurgia",
    "Obito": "Óbito",
    "Obito_Descricao": "Registro de informações relacionadas ao falecimento do paciente",
    "Acessar": "Acessar",
    "Select_Instituicao": "Selecione a instituição",
    "Edit_Identificacao": "Editar Paciente",
    "Add_Identificacao": "Novo Paciente",
    "ID_Paciente": "ID do Paciente",
    "Instituicao_ID": "ID da Instituição",
    Exportacao: "Exportação",
    "Pacientes": "Pacientes",
    Exportacao_info_1: "Quer incluir dados de outros formulários?",
    Exportar: "Exportar",
    esqueceu_sua_senha: "Esqueceu sua senha?",
    Users: "Usuários",
    Institution_Registration: "Cadastro da Instituição",
    Institution: "Instituição",
    Name_of_Institution: "Nome da Instituição",
    ZIP_Code: "CEP da Instituição",
    Institution_Address: "Endereço da Instituição",
    Institution_Telephone_Number: "Telefone da Instituição",
    CNES: "CNES da Instituição",
    Responsible: "Responsável",
    "date_invalid": "Data inválida. Verifique o dia, mês e ano.",
    "day_invalid": "Dia inválido para o mês informado.",
    "date_future": "Data não pode ser no futuro.",
    "date_past": "Data de nascimento muito antiga.",
    "ConfirmPassword": "Confirmar Senha",
    "Cancel": "Cancelar",
    "UserSavedSuccessfully": "Usuário salvo com sucesso",
    "Confirmation": "Confirmação",
    "Register_Success": "Cadastro realizado com sucesso",
    "Institutions_Management": "Gerenciamento de Instituições",
    Name_Responsible: "Nome",
    Email_Responsible: "E-mail",
    Telefone_Ramal_Responsible: "Telefone",
    Password: "Senha",
    Password_info: "Use 8 ou mais caracteres com uma mistura de letras, números e símbolos.",
    Confirm_Password: "Confirme à Senha",
    Register: "Cadastrar-se",
    Already_Registered: "Já é Registrado?",
    language: "Idioma",
    welcome: "Bem vindo CarduMICS",
    welcome_p2: "Por favor, entre com os seus dados de acesso!",
    user: "Usuario",
    password: "Senha",
    "Meu_Perfil": "Meu Perfil",
    remember_me: "Lembra de mim",
    invalid_data: "Dados inválidos",
    is_required: "Obrigatório",
    password_wismatch: "Senhas não conferem",
    login: "Conecte-se",
    dashboard: "Painel",
    new_patient_registration: "Cadastro de Novos Pacientes",
    my_patients: "Meus pacientes",
    generate_report: "Gerar Relatório",
    logout: "Sair do Sistema",
    my_summary: "Meu resumo",
    surgeries: "Cirurgias",
    "password_strength_error": "A senha deve ter no mínimo 8 caracteres, incluindo letras maiúsculas, minúsculas, números e caracteres especiais.",
    times: "Tempos",
    "Street": "Rua",
    "Number": "Número",
    "Complement": "Complemento",
    "Neighborhood": "Bairro",
    "City": "Cidade",
    "State": "Estado",
    survival: "Sobrevida",
    hours: "horas",
    days: "dias",
    in_30_days: "em 30 dias",
    IOT_h: "IOT",
    IOT_p: "Tempo até extubação",
    UTI_h: "UTI",
    UTI_p: "Tempo de UTIo",
    LOS_h: "LOS",
    LOS_p: "Tempo de internação",
    logoff: "Sair",
    Institutions: "Instituição",
    Records: "Registros",
    no_records_found: "nenhum registro encontrado",
    Details: "Detalhes",
    nome: "Nome",
    hospital: "Hospital",
    Criar_Paciente: "Criar Paciente",
    Categories: "Categorias",
    Form_for: "Formulário para",
    Salvar: "Salvar",
    identificacao: "Identificação",
    pre_operatorio: "Pré-operatório",
    escores: "Escores",
    anestesia: "Anestesia",
    incisao: "Incisão",
    circulacao_extracorporea: "Circulação Extracorpórea",
    cirurgia: "Cirurgia",
    pos_operatorio: "Pós-operatório",
    hemotransfusao: "Hemotransfusão",
    obito: "Óbito",
    sim: "Sim",
    nao: "Não",
    id_do_paciente: "ID do paciente",
    id_no_hospital: "ID no hospital",
    cpf: "CPF",
    idade: "Idade",
    sexo: "Sexo",
    altura_cm: "Altura (cm)",
    "Altura (cm)":  "Altura (cm)",
    altura_m: "Altura (m)",
    peso_g: "Peso (g)",
    peso_kg: "Peso (kg)",
    imc: "IMC",
    asc_m2: "ASC (m2)",
    has: "HAS",
    dm: "DM",
    DMid: "DM em uso de insulina",
    dpoc: "DPOC",
    iam_previo: "IAM prévio",
    ave_previo: "AVE prévio",
    fa_pre_operatoria: "FA pré-operatória",
    pre_habilitado: "Pré-habilitado",
    cirurgia_toracica_previa: "Cirurgia torácica prévia",
    feve_porcenta: "FEVE (%)",
    creatinina_mg_dl: "Creatinina (mg/dl)",
    angioplastia_previa: "Angioplastia prévia",
    euroscore_porcenta: "EUROscore (%)",
    sts_score_porcenta: "STS score (%)",
    uso_de_intubacao_seletiva: "Uso de intubação seletiva",
    metodo_de_intubacao_seletiva: "Método de intubação seletiva",
    bloqueio_regional: "Bloqueio regional",
    tecnica_de_bloqueio_regional: "Técnica de bloqueio regional",
    momento_do_bloqueio_regional: "Momento do bloqueio regional",
    monitorizacao_de_debito_minimamente_invasiva: "Monitorização de débito minimamente invasiva",
    monitor_minimamente_invasivo_utilizado: "Monitor minimamente invasivo utilizado",
    monitorizacao_de_debito_invasiva: "Monitorização de débito invasiva",
    monitor_invasivo_utilizado: "Monitor invasivo utilizado",
    monitorizacao_de_snc: "Monitorização de SNC",
    tipo_de_monitorizacao_de_snc: "Tipo de monitorizacão de SNC",
    manutencao_de_ventilacao_durante_a_cec: "Manutenção de ventilação durante a CEC",
    consumo_total_de_opioides: "Consumo total de opioides",
    uso_de_dexmedetomidina: "Uso de dexmedetomidina",
    extubacao_em_sala: "Extubação em sala",
    tipo_de_esternotomia: "Tipo de esternotomia",
    lateralidade_se_nao_mediana: "Lateralidade (se não mediana)",
    posicao_se_nao_mediana: "Posição (se não mediana)",
    tamanho_da_incisao_cm: "Tamanho da incisão (cm)",
    categoria_do_tamanho: "Categoria do tamanho",
    numero_de_incisoes_adicionais: "Número de incisões adicionais",
    incisao_de_trabalho_na_pele_nao_mediana: "Incisão de trabalho na pele (não mediana)",
    espaco_intercostal_aberto_nao_mediana: "Espaço intercostal aberto (não mediana)",
    conversao_para_esternotomia: "Conversão para esternotomia",
    motivo_da_conversao: "Motivo da conversão",
    tipo_de_canulacao: "Tipo de canulação",
    metodo_de_canulacao_periferica: "Método de canulação periférica",
    assistencia_sem_parada_cardiaca_beating_heart: "Assistência sem parada cardíaca (beating heart)",
    canulacao_arterial: "Canulação arterial",
    canula_arterial_utilizada_marca_especificacao: "Cânula arterial utilizada (Marca/Especificação)",
    tamanho_da_canula_arterial_fr: "Tamanho da cânula arterial (Fr)",
    canulacao_venosa: "Canulação venosa",
    canula_venosa_unica_utilizada_marca_especificacao: "Cânula venosa única utilizada (Marca/Especificação)",
    tamanho_da_canula_venosa_unica_fr: "Tamanho da cânula venosa única (Fr)",
    numero_de_estagios_da_canula_unica: "Número de estágios da cânula única",
    canula_venosa_superior_utilizada_marca_especificacao: "Cânula venosa superior utilizada (Marca/Especificação)",
    tamanho_da_canula_venosa_superior_fr: "Tamanho da cânula venosa superior (Fr)",
    canula_venosa_inferior_utilizada_marca_especificacao: "Cânula venosa inferior utilizada (Marca/Especificação)",
    tamanho_da_canula_venosa_inferior_fr: "Tamanho da cânula venosa inferior (Fr)",
    lacamento_das_cavas: "Laçamento das cavas",
    tipo_de_clampeamento: "Tipo de clampeamento",
    perfusao_cerebral_seletiva: "Perfusão cerebral seletiva",
    tempo_de_cec_min: "Tempo de CEC (min)",
    tempo_de_anoxia_clampeamento_min: "Tempo de anóxia/clampeamento (min)",
    tempo_de_perfusao_cerebral_seletiva_min: "Tempo de perfusão cerebral seletiva (min)",
    tempo_total_da_cirurgia_min_de_pele_a_pele: "Tempo total da cirurgia (min, de pele a pele)",
    cardioplegia_utilizada: "Cardioplegia utilizada",
    necessidade_de_repetir_cardioplegia: "Necessidade de repetir cardioplegia",
    tipo_de_infusao_da_cardioplegia: "Tipo de infusão da cardioplegia",
    temperatura_minima_em_cec_posicaoc: "Temperatura mínima em CEC (ºC)",
    fluxo_alvo_da_cec_ml_min: "Fluxo alvo da CEC (ml/min)",
    necessidade_de_assistencia_para_saida_de_cec: "Necessidade de assistência para saída de CEC",
    assistencia_utilizada_na_saida_de_cec: "Assistência utilizada na saída de CEC",
    uso_de_minicec: "Uso de miniCEC",
    eretor_da_espinha: "eretor da espinha",
    paraesternal: "paraesternal",
    subcostal: "subcostal",
    intercostal: "intercostal",
    serratil_anterior: "serrátil anterior",
    pre_incisional: "pré-incisional",
    pos_incisional: "pós-incisional",
    na_uti: "na UTI",
    bis: "BIS",
    qnox: "QNox",
    nirs: "NIRS",
    doppler_transcraniano: "Doppler transcraniano",
    saturacao_venosa_jugular: "Saturação venosa jugular",
    "1posicao_eic": "1º EIC",
    "2posicao_eic": "2º EIC",
    "3posicao_eic": "3º EIC",
    "4posicao_eic": "4º EIC",
    "5posicao_eic": "5º EIC",
    "6posicao_eic": "6º EIC",
    "7posicao_eic": "7º EIC",
    "8posicao_eic": "8º EIC",
    revascularizacao: "Revascularização",
    abordagem_valvar: "Abordagem valvar",
    abordagem_da_aorta: "Abordagem da Aorta",
    abordagem_aorta: "Abordagem da Aorta",
    "correcao_cardiopatia_congenita" : "Correção de Cardiopatia Congênita",
    "outros_procedimentos_cardiacos": "Outros Procedimentos Cardíacos",
    "uso_videotoracoscopia": "Uso de Videotoracoscopia",
    "uso_plataforma_robotica" : "Uso de Plataforma Robótica",
    correcao_de_cardiopatia_congenita: "Correção de cardiopatia congênita",
    uso_de_videotoracoscopia: "Uso de videotoracoscopia",
    resseccao_de_tumor_intracardiaco: "Ressecção de Tumor intracardíaco",
    transplante_cardiaco: "Transplante Cardíaco",
    implante_de_eletrodo_epicardico: "Implante de eletrodo epicárdico",
    janela_pleuropericardica: "Janela pleuropericárdica",
    pericardiectomia: "pericardiectomia",
    cox_maze: "Cox Maze",
    fechamento_de_auriculeta: "Fechamento de auriculeta",
    uso_de_plataforma_robotica: "Uso de plataforma robótica",
    plataforma_robotica_utilizada: "Plataforma robótica utilizada",
    revascularizacao_com_cec: "Revascularização com CEC",
    numero_de_coronarias_acometidas: "Número de coronárias acometidas",
    numero_de_coronarias_abordadas: "Número de coronárias abordadas",
    numero_de_enxertos_utilizados: "Número de enxertos utilizados",
    uso_de_atie: "Uso de ATIE",
    metodo_de_disseccao_da_atie: "Método de dissecção da ATIE",
    material_utilizado_na_disseccao_da_atie: "Material utilizado na dissecção da ATIE",
    uso_de_atid: "Uso de ATID",
    pinca_de_coronaria_convencional: "Pinça de coronária convencional",
    pinca_de_mini: "Pinça de mini",
    tesoura_de_potts_dietrich_convencional: "Tesoura de Potts/Dietrich convencional",
    tesoura_de_mini: "Tesoura de mini",
    bisturi_eletrico_monopolar_convencional: "Bisturi elétrico monopolar convencional",
    bisturi_eletrico_com_extensor_de_lamina: "Bisturi elétrico com extensor de lâmina",
    bisturi_harmonico: "Bisturi harmônico",
    bisturi_eletrico_bipolar: "bisturi elétrico bipolar",
    bisturi_de_video_hook: "Bisturi de vídeo Hook",
    bisturi_ligasure: "Bisturi Ligasure",
    plataforma_robotica: "Plataforma robótica",
    metodo_de_disseccao_da_atid: "Método de dissecção da ATID",
    material_utilizado_na_disseccao_da_atid: "Material utilizado na dissecção da ATID",
    retirada_endoscopica_da_radial: "Retirada endoscópica da radial",
    uso_de_a_radial: "Uso de A. radial",
    uso_de_a_epigastrica_inferior: "Uso de A. epigástrica inferior",
    uso_de_a_gastroepiploica: "Uso de A. gastroepiploica",
    uso_de_v_safena_magna: "Uso de V. safena magna",
    uso_da_tecnica_safena_no_touch: "Uso da técnica safena no-touch",
    retirada_endoscopica_da_safena: "Retirada endoscópica da safena",
    uso_de_enxertos_compostos: "Uso de enxertos compostos",
    uso_de_tenica_em_y: "Uso de ténica em Y",
    uso_de_anastomoses_sequenciais: "Uso de anastomoses sequenciais",
    uso_de_estabilizador_cardiaco: "Uso de estabilizador cardíaco",
    estabilizador_utilizado: "Estabilizador utilizado",
    uso_de_posicionador_cardiaco: "Uso de posicionador cardíaco",
    posicionador_utilizado: "Posicionador utilizado",
    material_utilizado_na_anastomose_coronariana: "Material utilizado na anastomose coronariana",
    marca_do_material_de_mini_utilizado: "Marca do material de mini utilizado",
    castroviejo_mini: "Castroviejo Mini",
    castroviejo_convencional: "Castroviejo convencional",
    pinca_robotica: "Pinça robótica",
    porta_agulhas_robotica: "Porta-agulhas robótica",
    angioplastia_programada_cirurgia_hibrida: "Angioplastia programada (cirurgia híbrida)",
    abordagem_da_valva_aortica: "Abordagem da valva aórtica",
    plastia_valvar_aortica: "Plastia valvar aórtica",
    troca_valvar_aortica: "Troca valvar aórtica",
    tecnica_de_plastia_valvar_aortica: "Técnica de plastia valvar aórtica",
    gradiente_medio_valvar_aortico_pos_cec: "Gradiente Médio Valvar Aórtico Pós-CEC",
    insuficiencia_aortica_pos_cec: "Insuficiência aórtica pós-CEC",
    protese_valvar_aortica: "Prótese valvar aórtica",
    tamanho_da_protese_valvar_aortica: "Tamanho da prótese valvar aórtica",
    protese_de_liberacao_rapida_aortica: "Prótese de liberação rápida aórtica",
    uso_de_protese_aortica_endovascular: "Uso de prótese aórtica endovascular",
    protese_aortica_com_tratamento_anticalcificante: "Prótese aórtica com tratamento anticalcificante",
    especificacoes_da_protese_aortica: "Especificações da prótese aórtica",
    leak_paravalvar_aortico: "Leak paravalvar aórtico",
    abordagem_da_valva_mitral: "Abordagem da valva mitral",
    via_de_acesso_da_valva_mitral: "Via de acesso da valva mitral",
    plastia_valvar_mitral: "Plastia valvar mitral",
    troca_valvar_mitral: "Troca valvar mitral",
    comissurotomia_mitral: "Comissurotomia mitral",
    uso_de_neocorda: "Uso de neocorda",
    especificacoes_da_neocorda: "Especificações da neocorda",
    uso_de_anel_mitral: "Uso de anel mitral",
    especificacoes_do_anel_mitral: "Especificações do anel mitral",
    resseccao_de_folheto_mitral: "Ressecção de folheto mitral",
    anuloplastia_posterior_mitral: "Anuloplastia posterior mitral",
    gradiente_medio_da_valva_mitral_pos_cec: "Gradiente médio da valva mitral pós-CEC",
    insuficiencia_mitral_pos_cec: "Insuficiência mitral pós-CEC",
    protese_valvar_mitral: "Prótese valvar mitral",
    tamanho_da_protese_valvar_mitral: "Tamanho da Prótese Valvar Mitral",
    protese_de_liberacao_rapida_mitral: "Prótese de liberação rápida mitral",
    uso_de_protese_mitral_endovascular: "Uso de prótese mitral endovascular",
    protese_mitral_com_tratamento_anticalcificante: "Prótese mitral com tratamento anticalcificante",
    especificacoes_da_protese_mitral: "Especificações da prótese mitral",
    leak_paravalvar_mitral: "Leak paravalvar mitral",
    fechamento_de_auriculeta_esquerda: "Fechamento de auriculeta esquerda",
    abordagem_da_valva_pulmonar: "Abordagem da valva pulmonar",
    plastia_valvar_pulmonar: "Plastia valvar pulmonar",
    troca_valvar_pulmonar: "Troca valvar pulmonar",
    tecnica_de_plastia_valvar_pulmonar: "Técnica de plastia valvar pulmonar",
    gradiente_medio_valvar_pulmonar_pos_cec: "Gradiente médio valvar pulmonar pós-CEC",
    insuficiencia_pulmonar_pos_cec: "Insuficiência pulmonar pós-CEC",
    protese_valvar_pulmonar: "Prótese valvar pulmonar",
    tamanho_da_protese_valvar_pulmonar: "Tamanho da prótese valvar pulmonar",
    protese_de_liberacao_rapida_pulmonar: "Prótese de liberação rápida pulmonar",
    uso_de_protese_pulmonar_endovascular: "Uso de prótese pulmonar endovascular",
    protese_pulmonar_com_tratamento_anticalcificante: "Prótese pulmonar com tratamento anticalcificante",
    especificacoes_da_protese_pulmonar: "Especificações da prótese pulmonar",
    leak_paravalvar_pumonar: "Leak paravalvar pumonar",
    abordagem_da_valva_tricuspide: "Abordagem da valva tricúspide",
    plastia_valvar_tricuspide: "Plastia valvar tricúspide",
    troca_valvar_tricuspide: "Troca valvar tricúspide",
    tecnica_de_plastia_valvar_tricuspide: "Técnica de plastia valvar tricúspide",
    especificacoes_do_anel_tricuspide: "Especificações do anel tricúspide",
    gradiente_medio_valvar_tricuspide_pos_cec: "Gradiente médio valvar tricúspide pós-CEC",
    insuficiencia_valvar_tricuspide_pos_cec: "Insuficiência valvar tricúspide pós-CEC",
    protese_valvar_tricuspide: "Prótese valvar tricúspide",
    tamanho_da_protese_valvar_tricuspide: "Tamanho da prótese valvar tricúspide",
    protese_de_liberacao_rapida_tricuspide: "Prótese de liberação rápida tricúspide",
    uso_de_protese_tricuspide_endovascular: "Uso de prótese tricúspide endovascular",
    protese_tricuspide_com_tratamento_anticalcificante: "Prótese tricúspide com tratamento anticalcificante",
    especificacoes_da_protese_tricuspide: "Especificações da prótese tricúspide",
    leak_paravalvar_tricuspide: "Leak paravalvar tricúspide",
    segmentos_da_aorta_abordados: "Segmentos da aorta abordados",
    reimplante_de_coronarias: "Reimplante de coronárias",
    preservacao_da_valva_aortica_nativa: "Preservação da valva aórtica nativa",
    uso_de_tubo_sintetico: "Uso de tubo sintético",
    tamanho_do_tubo_sintetico_mm: "Tamanho do Tubo Sintético (mm)",
    uso_de_tubo_valvado: "Uso de tubo valvado",
    tipo_de_valva_do_tubo_valvado: "Tipo de valva do tubo valvado",
    especificacoes_do_material_utilizado_na_aorta: "Especificações do material utilizado na Aorta",
    programacao_de_procedimento_hibrido: "Programação de Procedimento Híbrido",
    cardiopatia_congenita_abordada: "Cardiopatia congênita abordada",
    uso_de_pericardio: "Uso de pericárdio",
    uso_de_afastador_de_partes_moles: "Uso de afastador de partes moles",
    especificacoes_do_afastador_de_partes_moles: "Especificações do afastador de partes moles",
    uso_de_fixacao_rigida: "Uso de fixação rígida",
    sitio_da_fixacao_rigida: "Sítio da fixação rígida",
    especificacoes_da_protese_de_fixacao_rigida: "Especificações da prótese de fixação rígida",
    pericardiotomia_posterior_esquerda: "Pericardiotomia posterior esquerda",
    drenagem_pericardica: "Drenagem pericárdica",
    drenagem_pleural: "Drenagem pleural",
    tipo_de_dreno_pleural_utilizado: "Tipo de dreno pleural utilizado",
    tempo_de_permanencia_em_unidade_de_terapia_intensiva_horas: "Tempo de permanência em Unidade de Terapia Intensiva (horas)",
    tempo_de_permanencia_em_internacao_hospitalar_dias: "Tempo de permanência em internação Hospitalar (dias)",
    tempo_de_extubacao_apos_admissao_na_uti_horas: "Tempo de extubação após admissão na UTI (horas)",
    dor_pos_operatoria: "Dor pós-operatória",
    escala_visual_analogica_da_dor: "Escala visual analógica da dor",
    tempo_para_inicio_de_mobilizacao_no_leito_horas: "Tempo para início de mobilização no leito (horas)",
    tempo_para_inicio_de_deambulacao_horas: "Tempo para início de deambulação (horas)",
    infeccao: "Infecção",
    deiscencia_de_ferida_operatoria_: "Deiscência de ferida operatória ",
    infarto_do_miocardio_pos_operatorio: "Infarto do miocárdio pós-operatório",
    necessidade_de_nova_revascularizacao_nao_programada_durante_internacao_: "Necessidade de nova revascularização não programada durante internação ",
    necessidade_de_primeira_dialise: "Necessidade de primeira diálise",
    ave_novo_com_sequela: "AVE novo com sequela",
    fibrilacao_atrial_pos_operatoria: "Fibrilação Atrial pós-operatória",
    parada_cardiorrespiratoria_revertida_no_pos_operatorio: "Parada cardiorrespiratória revertida no pós-operatório",
    necessidade_de_dispositivo_de_assistencia_circulatoria_no_pos_operatorio: "Necessidade de Dispositivo de Assistência Circulatória no pós-operatório",
    tipo_de_dispositivo_de_assistencia_circulatoria_: "Tipo de dispositivo de assistência circulatória ",
    tempo_para_inicio_da_retirada_dos_drenos_horas: "Tempo para início da retirada dos drenos (horas)",
    transfusao_de_hemoderivados: "Transfusão de hemoderivados",
    momento_da_transfusao: "Momento da transfusão",
    elemento_transfundido: "Elemento transfundido",
    obito_intra_hospitalar: "Óbito intra-hospitalar",
    motivo_do_obito: "Motivo do óbito",
    momento_do_obito: "Momento do óbito",
    obito_durante_seguimento: "Óbito durante seguimento",
    tempo_do_obito_apos_cirurgia_dias: "Tempo do óbito após cirurgia (dias)",
    sem_canulacao: "Sem canulação",
    periferica: "Periférica",
    central: "Central",
    mista: "Mista",
    puncao: "Punção",
    disseccao: "Dissecção",
    puncao_por_visao_direta: "Punção por visão direta",
    aorta_ascendente: "Aorta ascendente",
    arco_aortico: "Arco aórtico",
    tronco_braquiocefalico: "Tronco braquiocefálico",
    axilar: "Axilar",
    subclavia: "Subclávia",
    carotidea: "Carotídea",
    femoral: "Femoral",
    iliaca_externa: "Ilíaca externa",
    campo_aberto: "CAMPO ABERTO",
    "0_50": "[0;50]",
    atrial_unica: "Atrial única",
    bicaval: "Bicaval",
    femoral_unica: "Femoral única",
    jugular_unica: "Jugular única",
    jugular__femoral: "Jugular + femoral",
    cava_superior__femoral: "Cava superior + femoral",
    bicaval__cava_esquerda: "Bicaval + cava esquerda",
    outra: "Outra",
    estagio_unico: "Estágio único",
    duplo_estagio: "Duplo estágio",
    triplo_estagio: "Triplo estágio",
    multiperfurada: "Multiperfurada",
    sem_clampeamento: "Sem clampeamento",
    convencional: "Convencional",
    endoclamp: "Endoclamp",
    chitwood: "Chitwood",
    "0_2000": "[0;2000]",
    "0_1000": "[0;1000]",
    cirurgia_em_assistencia: "Cirurgia em assistência",
    del_nido: "Del Nido",
    custodiol: "Custodiol",
    anterograda: "anterógrada",
    retrograda: "retrógrada",
    combinada: "combinada",
    "10_40": "[10;40]",
    "0_10000": "[0;10000]",
    balao_intra_aortico: "Balão intra-aórtico",
    centrimag: "Centrimag",
    ecmo_va: "ECMO VA",
    ecmo_vv: "ECMO VV",
    berlin_heart: "Berlin Heart",
    heartmate: "HeartMate",
    identificacao_description: "Formulário que coleta dados básicos de identificação do paciente",
    pre_operatorio_description: "Avaliação prévia à cirurgia, com foco em exames e preparação do paciente",
    escores_description: "Coleta de escores clínicos para avaliação do estado de saúde do paciente",
    anestesia_description: "Informações sobre o processo anestésico e sedação do paciente",
    incisao_description: "Registro do início da cirurgia, com detalhes sobre a incisão",
    circulacao_extracorporea_description: "Informações sobre o uso da circulação extracorpórea durante a cirurgia",
    cirurgia_description: "Detalhes do procedimento cirúrgico principal realizado no paciente",
    pos_operatorio_description: "Monitoramento e cuidados imediatos no pós-operatório",
    hemotransfusao_description: "Registro de transfusões sanguíneas realizadas durante ou após a cirurgia",
    obito_description: "Registro de informações relacionadas ao falecimento do paciente",
    "uso_intubacao_seletiva": "Uso de intubação seletiva",
    "monitorizacao_debito_min_invasiva": "Monitorização de débito minimamente invasiva",
    "monitorizacao_debito_invasiva": "Monitorização de débito invasiva",
    "monitorizacao_snc": "Monitorização de SNC",
    "manutencao_ventilacao_cec": "Manutenção de ventilação durante a CEC",
    "consumo_total_opioides": "Consumo total de opioides",
    "uso_dexmedetomidina": "Uso de dexmedetomidina",
    "conversao_esternotomia": "Conversão para esternotomia",
    "Esternotomia": "Esternotomia",
    "Miniesternotomia em J": "Miniesternotomia em J",
    "Miniesternotomia em L": "Miniesternotomia em L",
    "Toracotomia anterior direita": "Toracotomia anterior direita",
    "Toracotomia axilar direita": "Toracotomia axilar direita",
    "Toracotomia periareolar direita / MAMICS": "Toracotomia periareolar direita / MAMICS",
    "Toracotomia anterolateral esquerda": "Toracotomia anterolateral esquerda",
    "Toracotomia lateral esquerda": "Toracotomia lateral esquerda",
    "Sem esternotomia": "Sem esternotomia",
    "Completa/Convencional": "Completa/Convencional",
    "Parcial em J": "Parcial em J",
    "Parcial em L": "Parcial em L",
    "Parcial em T invertido": "Parcial em T invertido",
    "Parcial em T": "Parcial em T",
    "H deitado": "H deitado",
    "Esquerda": "Esquerda",
    "Direita": "Direita",
    "Anterior": "Anterior",
    "Anterolateral": "Anterolateral",
    "Lateral/Axilar": "Lateral/Axilar",
    "1º EIC": "1º EIC",
    "2º EIC": "2º EIC",
    "3º EIC": "3º EIC",
    "4º EIC": "4º EIC",
    "5º EIC": "5º EIC",
    "6º EIC": "6º EIC",
    "7º EIC": "7º EIC",
    "8º EIC": "8º EIC",
    "Não aferida": "Não aferida",
    "Edit_CirculacaoExtracorporea": "Editar Circulação Extracorpórea",
    "Add_CirculacaoExtracorporea": "Adicionar Circulação Extracorpórea",
    "Edit_Cirurgia": "Editar Cirurgia",
    "Add_Cirurgia": "Adicionar Cirurgia",
    "Strattner Intuitive": "Strattner Intuitive",
    "Hugo": "Hugo",
    "Visão direta": "Visão direta",
    "Vídeo-assistida": "Vídeo-assistida",
    "Endoscópica": "Endoscópica",
    "Robótica por esternotomia": "Robótica por esternotomia",
    "Robótica por toracotomia lateral": "Robótica por toracotomia lateral",
    "Robótica endoscópica": "Robótica endoscópica",
    "Pinça de coronária convencional": "Pinça de coronária convencional",
    "Pinça de mini": "Pinça de mini",
    "Pinça robótica": "Pinça robótica",
    "Porta-agulhas robótico": "Porta-agulhas robótico",
    "Tesoura robótica": "Tesoura robótica",
    "Tesoura de Potts/Dietrich convencional": "Tesoura de Potts/Dietrich convencional",
    "Tesoura de mini": "Tesoura de mini",
    "Bisturi elétrico monopolar convencional": "Bisturi elétrico monopolar convencional",
    "Bisturi elétrico com extensor de lâmina": "Bisturi elétrico com extensor de lâmina",
    "Bisturi harmônico": "Bisturi harmônico",
    "Bisturi elétrico bipolar": "Bisturi elétrico bipolar",
    "Bisturi de vídeo Hook": "Bisturi de vídeo Hook",
    "Bisturi Ligasure": "Bisturi Ligasure",
    "Plataforma robótica": "Plataforma robótica",
    "Medtronic Octopus": "Medtronic Octopus",
    "Medtronic Octopus Nuvo": "Medtronic Octopus Nuvo",
    "Getinge": "Getinge",
    "Medtronic Starfish": "Medtronic Starfish",
    "Getinge Acrobat": "Getinge Acrobat",
    "(mmHg)": "(mmHg)",
    "Comissurotomia": "Comissurotomia",
    "Suspensão de postes comissurais": "Suspensão de postes comissurais",
    "Plicatura valvar": "Plicatura valvar",
    "Ampliação de folheto": "Ampliação de folheto",
    "Anuloplastia": "Anuloplastia",
    "Sem leak": "Sem leak",
    "Mínimo": "Mínimo",
    "Discreto": "Discreto",
    "Moderado": "Moderado",
    "Importante": "Importante",
    "Não aferido": "Não aferido",
    "Sem insuficiência": "Sem insuficiência",
    "Mínima": "Mínima",
    "Discreta": "Discreta",
    "Moderada": "Moderada",
    "Prótese biológica": "Prótese biológica",
    "Prótese mecânica": "Prótese mecânica",
    "Homoenxerto": "Homoenxerto",
    "Anuloplastia a DeVega": "Anuloplastia a DeVega",
    "Implante de neocorda": "Implante de neocorda",
    "Desinserção e reinserção tricúspide": "Desinserção e reinserção tricúspide",
    "Papilarotomia": "Papilarotomia",
    "Encurtamento de cordas tendíneas": "Encurtamento de cordas tendíneas",
    "Bicuspidização": "Bicuspidização",
    "Massiva": "Massiva",
    "Torrencial": "Torrencial",
    "Atriotomia esquerda": "Atriotomia esquerda",
    "Transeptal": "Transeptal",
    "Ferida operatória": "Ferida operatória",
    "Outro sítio": "Outro sítio",
    "Esternal": "Esternal",
    "Inguinal": "Inguinal",
    "Intercostal": "Intercostal",
    "Periareolar": "Periareolar",
    "Edit_PosOperatorio": "Editar Pós-Operatório",
    "Add_PosOperatorio": "Adicionar Pós-Operatório",
    "Intra-operatório": "Intra-operatório",
    "Pós-operatório": "Pós-operatório",
    "Hemácias": "Hemácias",
    "Plaquetas": "Plaquetas",
    "Plasma Fresco Congelado": "Plasma Fresco Congelado",
    "Crioprecipitado": "Crioprecipitado",
    "Fibrinogênio": "Fibrinogênio",
    "Complexo protrombínico": "Complexo protrombínico",
    "Add_Hemotransfusao": "Adicionar Hemotransfusão",
    "ConfirmAction": "Tem certeza que deseja",
    "Activate": "ativar",
    "Delete": "excluir",
    "User": "o usuário",
    "UserManagement": "Gerenciamento de Usuários",
    "NewUser": "Novo Usuário",
    "ID": "ID",
    "Name": "Nome",
    "Email": "Email",
    "Deleted": "Excluído?",
    "Actions": "Ações",
    "EditUser": "Editar Usuário",
    "Endereço": "Endereço",
    "Ações": "Ações",
    "Editar Instituição": "Editar Instituição",
    "Nova Instituição": "Nova Instituição",
    "Telefone": "Telefone",
    "CEP": "CEP"
}

export default br;